import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { BsArrowRight, BsCheck2Circle, BsStarFill } from "react-icons/bs";
import { FiUser, FiPhone, FiMail, FiMessageSquare } from "react-icons/fi";
import { FaQuoteLeft } from "react-icons/fa";
import "./ServicePage.css";
import intelligent_automation from '../../Images/Services/intelligent_automation.png';
import ai_chatbot from '../../Images/Services/ai_chatbot.png';
import eam from '../../Images/Services/eam.png';
import app_sec from '../../Images/Services/app_sec.png';
import uaf from '../../Images/Services/uaf.png';
import waf from '../../Images/Services/waf.png';
import app_dev from '../../Images/Services/app_dev.png';
import adobe from '../../Images/Services/adobe.png';
import corel from '../../Images/Services/corel.png';
import cloud_mgmt from '../../Images/Services/cloud_mgmt.png';
import ias from '../../Images/Services/ias.png';
import sec_devops from '../../Images/Services/sec_devops.png';
import insp_mgmt from '../../Images/Services/insp_mgmt.png';
import lowCode from '../../Images/Services/lowCode.png';
import fin_erp from '../../Images/Services/fin_erp.png';
import customer_vendor_reg from '../../Images/Services/customer_vendor_reg.png';
import itsm from '../../Images/Services/itsm.png';
import esm from '../../Images/Services/esm.png';
//import smartclass from '../../Images/Services/smartclass.png';

import field_force_mgmt from '../../Images/Services/field_force_mgmt.png';
 
 

const ServicePage = () => {
  const { serviceCategory, serviceType } = useParams();
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // Simulating data fetching
  const [serviceData, setServiceData] = useState(null);

  useEffect(() => {
    // Simulate fetching data based on URL params
    const fetchData = async () => {
      // Mock data for demonstration
      const mockServiceData = {
        "AI&GenAI": {
          "Intelligent Automation": {
            title: "Intelligent Automation",
            subtitle: "Drive Innovation with Intelligent Automation",
            description: "Transform operations with intelligent automation. Robotize manual activities, streamline workflows, reduce errors, and enhance efficiency, empowering your team for strategic growth.",
            features: [
              {
                name: "Handling Complex Processes",
                tagline: "Many business processes involve unstructured data (emails, documents, images) and require human-like judgment.",
                description: "Point automation struggles with these complexities, while IA, with its AI capabilities, can process and understand such data."
              },
              {
                name: "End-to-End Automation",
                tagline: "IA enables the automation of entire workflows, not just isolated tasks.",
                description: "This leads to greater efficiency and reduces bottlenecks that can occur when automating only parts of a process."
              },
              {
                name: "Adaptability and Learning",
                tagline: "IA systems can learn from data and adapt to changing conditions.",
                description: "This allows for continuous improvement and reduces the need for constant manual adjustments.\nPoint automation is typically rigid and requires manual updates when processes change."
              },
              {
                name: "Enhanced Decision-Making",
                tagline: "IA can automate complex decisions based on data analysis and AI insights.",
                description: "This leads to faster and more accurate decision-making, improving overall business performance."
              }, 
              {
                name: "Improved Customer Experience",
                tagline: "IA can automate customer interactions, providing faster and more personalized service.",
                description: "This can lead to increased customer satisfaction and loyalty."
              }
            ],
            benefits: [
              "Increased Efficiency: Faster processing times and reduced manual effort.",
              "Reduced Costs: Lower operational expenses through automation.",
              "Improved Accuracy: Minimized human errors and increased data integrity.",
              "Enhanced Productivity: Employees can focus on higher-value tasks.",
              "Faster Decision-Making: Real-time insights and automated decision-making.",
              "Improved Customer Experience: Faster response times and personalized services.",
              "Increased Scalability: Ability to handle fluctuating workloads and business growth.",
              "Better Compliance: Automated processes ensure adherence to regulations.",
              "Data-Driven Insights: Analytics and reporting provide valuable business intelligence.",
              "Faster Innovation: Automating routine tasks frees up resources for innovation.",
              "Improved employee satisfaction: Removing mundane repetitive tasks from their workload.",
              "Greater business agility: The ability to quickly adapt to market changes."
            ],
            image: intelligent_automation,
            caseStudies: [
              {
                client: "Global Financial Services Firm",
                challenge: "Needed to transition 5,000+ employees to remote work during pandemic",
                solution: "Implemented comprehensive digital workplace solution with cloud-based tools and secure access",
                results: "98% operational continuity with 25% increase in employee satisfaction"
              }
            ]
          },
          "AI ChatBots": {
            title: "AI ChatBots",

            subtitle: "Your Intelligent Assistant, Always On.",
            description: "Transform your business with AI Chatbots. Improve customer service, reduce costs, and unlock new growth opportunities through automation",
            features: [
              {
                name: "Natural Language Processing (NLP):",
                tagline: "Understanding and responding to human language.",
                description: "Sentiment analysis & Intent recognition."
              },
              {
                name: "Personalization:",
                tagline: "User profile creation.",
                description: "Tailored recommendations & Personalized greetings."
              },
              {
                name: "Integration:",
                tagline: "CRM integration.",
                description: "E-commerce platform integration & Knowledge base integration."
              },
              {
                name: "Automation:",
                tagline: "Automated responses to FAQs.",
                description: "Task automation (e.g., scheduling appointments) & Order tracking."
              },
              {
                name: "Multi-Platform Support:",
                tagline: "Social media integration.",
                description: "Website integration & social media integration."
              } ,
              {
                name: "Analytics and Reporting:",
                tagline: "Conversation tracking.",
                description: "Performance metrics & User behavior analysis."
              }  
            ],
            benefits: [
              "Increased Customer Satisfaction: Faster response time, personalized support, 24X7 availability.",
              "Increased Sales: Personalized product recommendations, improved lead generation, streamlined checkout process.",
              "Reduced Costs: Lower customer support expenses, increased efficiency, reduced operational overhead.",
              "Improved Efficiency: Automated tasks, faster access to information, streamlined workflows.",
              "Enhanced User Experience: Convenient and accessible support, personalized interactions, instant answers.",
              "Data Driven Insights: Understanding customer trends, identifying areas for improvement, improving products and services.",
              "Scalability: Ability to handle large volumes of inquiries, consistent performance during peak times.",
            
            ],
            image: ai_chatbot,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
           
        },
        "Products": {
          "Adobe": {
            title: "Adobe",
            subtitle: "",
            description: "Turn manual document processes into efficient digital ones with Adobe Document Cloud - featuring the world’s leading PDF and e-signature solutions.",
            features: [
              
              {
                name: "Adobe Acrobat Reader",
                tagline: "",
                description: "Adobe Acrobat Reader is the free, trusted PDF viewer that lets you view, share, comment on, sign and collaborate on PDFs across desktop and mobile. Easily scan documents, fill out forms and stay connected with your team — wherever you work."
              }, 
              {
                name: "Adobe Acrobat",
                tagline: "",
                description: "Adobe Acrobat lets you create, edit, convert and manage PDFs effortlessly. Collaborate in real time, e-sign documents, collect signatures and stay productive anywhere. It's your all-in-one app for handling any PDF task, with powerful tools and cloud integration built in."
              },
              {
                name: "Adobe Acrobat Pro",
                tagline: "",
                description: "Adobe Acrobat Pro is the all-in-one PDF software that lets you create, edit, convert, protect, and sign PDF documents with ease. Acrobat Pro ensures your documents are professional, secure and shareable across devices and platforms."
              },
             
              {
                name: "Adobe PhotoShop",
                tagline: "",
                description: "Create beautiful graphics and photos with industry-leading tools for photo editing."
              },
              {
                name: "Adobe Premiere Pro",
                tagline: "",
                description: "Transform your video into a piece of art with simple drag & drop interface and powerful editing tools!"
              },

              {
                name: "Adobe Express",
                tagline: "",
                description: "Your all-in-one AI content creation app which createS standout content quickly with Adobe Express. Use AI to generate images, videos, social posts and more. Then customize every detail to make it fast, intuitive and yourown."
              },
                 {
                name: "Adobe Illustrator",
                tagline: "",
                description: "Adobe Illustrator used by designers to create logos, icons, typography, illustrations, infographics and complex artworks for print, web, video and mobile. With precision tools and seamless integration with other Adobe apps, Illustrator empowers users to create scalable and pixel-perfect designs with professional-grade quality."
              },
              
              
              {
                name: "AI Assistant for Acrobat",
                tagline: "",
                description: "Work smarter with the AI Assistant in Acrobat. Quickly summarize lengthy documents, simplify complex legal or technical language, and ask natural-language questions to get instant, accurate answers—all within your PDF workspace."
              },
              {
                name: "Adobe Firefly",
                tagline: "",
                description: "Adobe Firefly is a family of generative AI tools designed to help you create images, text effects and designs using simple text prompts.Whether you're generating visuals for social media, product mockups or creative concepts, Firefly brings your ideas to life with speed, style and Adobe-quality precision-right from your browser or integrated into Adobe apps."
              }, 
                {
                  name: "Adobe Acrobat Sign",
                  tagline: "",
                  description: "Adobe Acrobat Sign accelerates your document workflows with the trusted e-signature solution that combines the power of Adobe Acrobat in one seamless package. Easily send, sign, track and manage documents securely from anywhere, on any device."
                },
               
              {
                name: "Adobe Customer data platform",
                tagline: "",
                description: "Adobe’s Customer Data Platform (CDP) brings together online and offline data from every channel to build unified customer and account profiles. With robust security and privacy-focused collaboration tools, it helps you create high-value audience segments and deliver personalized experiences—across both B2B and B2C use cases. "
              }, 
              {
                name: "Adobe Campaign management",
                tagline: "",
                description: "Deliver real-time, personalized multi-channel campaigns for both B2B and B2C audiences. Adobe’s campaign management tools empower marketing and sales teams to collaborate seamlessly, ensuring consistent messaging and optimized customer experiences across email, web, mobile and more."
              }, 
              {
                name: "Adobe Analytics",
                tagline: "",
                description: "Adobe Analytics provides real-time insights across every touchpoint — online and offline — helping you understand customer journeys, optimize product experiences and measure content performance. Make smarter decisions with powerful data visualization, segmentation and predictive analytics tools."
              }, 
              {
                name: "Adobe Commerce",
                tagline: "",
                description: "Adobe Commerce offers enterprise-grade tools built on a flexible, composable platform—enabling you to deliver personalized, relevant shopping experiences across B2B and B2C channels. Easily manage multiple brands, regions and business models from a single, scalable solution."
              }, 
              {
                name: "Adobe Workflow Management",
                tagline: "",
                description: "Adobe Workfront simplifies enterprise workflow management by helping cross-functional teams centralize, coordinate and execute work efficiently. From planning to delivery, it enables real-time collaboration, visibility and alignment across your entire organization."
              },  
         
            ],
            benefits: [
              "Adobe Journey Optimizer B2B Edition. Empower marketing and sales teams to engage buying groups with personalised, AI-powered content and journeys.",
              "Adobe Product Analytics. Unify customer journey insights across marketing and product teams.",
              "Adobe Marketo Engage. Use a B2B marketing automation platform to attract, segment and nurture prospects and score and manage leads. ",
              "Adobe Mix Modeler. Measure the impact of every marketing dollar spent across paid, earned and owned channels to optimise your marketing investments.",
              "Adobe Content Analytics. Create relevant and compelling content by leveraging AI-powered creative asset measurement tools.",
              "Adobe Web and Mobile Analytics. Understand visitor behaviour across all your digital properties with real-time data and in-depth analyses.",
              "Adobe Customer Journey Analytics. Bring together cross-channel customer data with easy-to-use visualisation tools to generate insights across the customer journey.",
              
            ],
            image:adobe,
            caseStudies: [
              {
                client: "Global Financial Services Firm",
                challenge: "Needed to transition 5,000+ employees to remote work during pandemic",
                solution: "Implemented comprehensive digital workplace solution with cloud-based tools and secure access",
                results: "98% operational continuity with 25% increase in employee satisfaction"
              }
            ]
          },
          "Corel": {
            title: "Corel",

            subtitle: "Your Intelligent Assistant, Always On.",
            description: "Embark on a design journey with powerful tools for vector illustration, layout, photo editing, and typography.",
            features: [
              
              {
                name: "CorelDRAW Standard",
                tagline: "",
                description: "Graphic design software tailored for enthusiasts, small teams, and home-based businesses to create stunning layouts, illustrations, and graphics with ease."
              },
              {
                name: "CorelDRAW Go",
                tagline: "",
                description: "Create beyond templates with effortless online graphic design, perfect for quick edits and on-the-go creativity without the need to install software."
              },
              {
                name: "CorelDRAW Graphics Suite (Windows/Mac)",
                tagline: "",
                description: "Complete graphic design software collection for creative professionals — from vector illustration and layout to photo editing and typography, all in one powerful suite."
              },
              {
                name: "CorelDRAW Graphics Suite – Business (Windows/Mac)",
                tagline: "",
                description: "Professional graphic design software tailored for business and enterprise needs — ideal for creating high-impact marketing materials, brand assets, and visual content at scale."
              },
              {
                name: "CorelDRAW Technical Suite",
                tagline: "",
                description: "Professional technical illustration and drafting software designed for creating complex documentation, schematics, and engineering visuals with pinpoint accuracy."
              } ,
              {
                name: "Corel Vector",
                tagline: "",
                description: "Web-based vector app for design hobbyists and aspiring pros, offering an intuitive interface and powerful tools for logo design, illustrations, and more — no downloads needed."
              }  
              

            ],
            benefits: [
              "AI-Powered Features – CorelDRAW integrates AI-based tools such as PowerTRACE™ for converting raster images to vectors and automated adjustments, enhancing efficiency and design accuracy.",
              "Advanced Typography and Layout Features – It includes professional typography tools, text effects, and layout options, ideal for creating brochures, business cards, and other print materials.",
              "Cross-Platform Compatibility – CorelDRAW is available on Windows, Mac, and as a web-based version (Corel Vector), ensuring seamless access and collaboration across different devices.",
              "User-Friendly Interface – The software provides an intuitive and customizable interface that enhances productivity and makes it easy for both beginners and professionals to create stunning designs.",
              "Comprehensive Graphic Design Tools – CorelDRAW offers a wide range of tools for vector illustration, page layout, photo editing, and typography, making it a powerful all-in-one design suite.",
            
            ],
            image:corel,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
           
        },
        "Security": {
          "Unified End Point Management": {
            title: "Unified End Point Management",
            subtitle: "Secure Every Endpoint, Simplify IT. (Focuses on security and ease of use)",
            description: "One Platform, Total Device Control.  (Highlights the unified aspect)",
            features: [
              {
                name: "Device Enrollment and Provisioning:",
                tagline: "Automated onboarding for various device types.",
                description: "Over-the-air  configuration and setup.  \n Support for Bring Your Own Device (BYOD) policies."
              },
              {
                name: "Mobile Device Management (MDM):",
                tagline: "Policy enforcement (passwords, encryption, etc.).",
                description: "Remote lock and wipe capabilities. \n App management (installation, updates, removal). \n Location tracking and geofencing."
              },
              {
                name: "Mobile Application Management (MAM):",
                tagline: "Secure containerization of corporate apps and data.",
                description: "App-specific policy enforcement. \n App distribution and updates."
              },
              {
                name: "Software Distribution & Patching:",
                tagline: "Software deployment and patching.",
                description: "Operating system management. \n Remote desktop control."
              },
              {
                name: "IoT Device Management:",
                tagline: "Device registration and authentication.",
                description: "Firmware updates, Security monitoring and threat detection."
              },
              {
                name: "Reporting and Analytics:",
                tagline: "Real-time visibility into device status and security posture.",
                description: "Customizable reports and dashboards. \n Auditing and compliance tracking."
              },
              {
                name: "Security Management:",
                tagline: "Threat detection and response.",
                description: "Data loss prevention (DLP).  \n Access control and identity management.  \n Compliance reporting."
              },
              {
                name: "Workspace Management:",
                tagline: "Delivery of virtual applications and desktops.",
                description: "User environment personalization."
              },
            ],
            benefits: [
              "Enhanced Security: Reduced risk of data breaches and malware infections. Improved compliance with regulatory requirements. Centralized security policy enforcement.",
              "Reduced IT Costs: Consolidated management of all endpoints. Automation of routine tasks. Reduced support costs.",
              "Increased Productivity: Simplified device onboarding and management. Seamless access to corporate resources. Improved user experience.",
              "Improved Compliance: Simplified auditing and reporting. Enforcement of data privacy regulations.",
              "Greater Flexibility and Scalability: Support for diverse device types and operating systems. Ability to scale to meet the needs of a growing organization. Enables better support for remote workforces.",
              "Centralized Control: Single pane of glass management. Faster response to security threats. Consistent policy enforcement."
            ],
            image:uaf,
            caseStudies: [
              {
                client: "Global Financial Services Firm",
                challenge: "Needed to transition 5,000+ employees to remote work during pandemic",
                solution: "Implemented comprehensive digital workplace solution with cloud-based tools and secure access",
                results: "98% operational continuity with 25% increase in employee satisfaction"
              }
            ]
          },
          "Application Security": {
            title: "Application Security",
            subtitle: "Securing the Software that Powers Your World.",
            description: "By implementing robust application security measures, organizations can safeguard their digital assets and maintain a strong security posture.",
            features: [
              {
                name: "Secure Coding Practices:",
                tagline: "Training and guidelines for developers.",
                description: "Code reviews and static analysis."
              },
              {
                name: "Vulnerability Scanning:",
                tagline: "Dynamic Application Security Testing (DAST).",
                description: "Static Application Security Testing (SAST). \n Software Composition Analysis (SCA)."
              },
              {
                name: "Runtime Application Self-Protection (RASP):",
                tagline: "Real-time threat detection and prevention.",
                description: "Protection against zero-day exploits."
              },
              {
                name: "Web Application Firewalls (WAF):",
                tagline: "Filtering and monitoring HTTP traffic.",
                description: "Protection against common web attacks (e.g., SQL injection, cross-site scripting)."
              },
              {
                name: "API Security:",
                tagline: "Authentication and authorization.",
                description: "Rate limiting and threat detection."
              },
              {
                name: "Security Testing Automation:",
                tagline: "Integration with CI/CD pipelines.",
                description: "Automated vulnerability assessments."
              },
              {
                name: "Threat Modeling:",
                tagline: "",
                description: "Identifying potential threats, and vulnerabilities during the design phase of applications."
              }
            ],
            benefits: [
              "Reduced Risk of Data Breaches: Protection against unauthorized access and data loss. Minimization of financial and reputational damage.",
              "Improved Compliance: Adherence to industry regulations and standards (e.g., PCI DSS, GDPR). Simplified auditing and reporting.",
              "Enhanced Customer Trust: Demonstration of commitment to data security. Increased confidence in online services.",
              "Faster Development Cycles: Early detection and remediation of vulnerabilities. Reduced need for costly post-deployment fixes.",
              "Increased Application Reliability: Protection against disruptions and downtime. Ensuring business continuity.",
              "Cost Savings: Proactive security measures are more cost-effective than reactive ones. Avoiding the costs associated with data breaches.",
              "Protection of Intellectual Property: Securing the code and data that is at the core of many businesses."
            ],
            image: app_sec,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          "Web Application Firewall": {
            title: "Web Application Firewall",
            subtitle: "Fortifying Your Online Presence with Advanced Web Protection.",
            description: "A Web Application Firewall (WAF) is a crucial security tool for protecting web applications. Here's a breakdown of taglines, features, and benefits:",
            features: [
              {
                name: "Protection Against Common Web Attacks:",
                tagline: "SQL injection prevention.",
                description: "Cross-site scripting (XSS) protection. \n Cross-site request forgery (CSRF) defense. \n Protection against OWASP Top 10 vulnerabilities."
              },
              {
                name: "Real-Time Threat Detection and Blocking:",
                tagline: "Monitoring HTTP/HTTPS traffic.",
                description: "Identifying and blocking malicious requests. \n Behavioral analysis to detect anomalies."
              },
              {
                name: "Customizable Security Rules:",
                tagline: "Creating and implementing specific security policies.",
                description: "Tailoring protection to individual application needs."
              },
              {
                name: "Layer 7 Protection:",
                tagline: "Operating at the application layer to analyze content.",
                description: "Providing deeper inspection than traditional firewalls."
              },
              {
                name: "Bot Protection:",
                tagline: "Identifying and blocking malicious bots.",
                description: "Preventing automated attacks like scraping and credential stuffing."
              },
              {
                name: "Logging and Reporting:",
                tagline: "Providing detailed logs of web traffic and security events.",
                description: "Generating reports for analysis and compliance."
              },
              {
                name: "API Protection:",
                tagline: "",
                description: "Securing API endpoints from malicious traffic."
              }
            ],
            benefits: [
              "Enhanced Web Application Security: Reducing the risk of data breaches and cyberattacks. Protecting sensitive data and customer information.",
              "Improved Compliance: Meeting industry regulations and standards (e.g., PCI DSS). Simplifying compliance audits.",
              "Increased Application Availability: Preventing attacks that can cause downtime. Ensuring uninterrupted service for users.",
              "Protection Against Zero-Day Exploits: Using behavioral analysis to detect unknown threats. Providing an extra layer of defense against emerging vulnerabilities.",
              "Reduced Risk of Financial and Reputational Damage: Minimizing the impact of successful cyberattacks. Maintaining customer trust and confidence.",
              "Centralized Management: Easily managing and updating security policies. Gaining visibility into web application traffic.",
              "Cost Efficiency: By preventing attacks, WAFs can save companies from costly data breaches."
            ],
            image: waf,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          // More services would be defined here
        },
        "Application Management": {
          "Application Development": {
            title: "Application Development",
            subtitle: "We have developed a comprehensive platform-based approach that enables us to plan, design, build, deploy and manage customizable solutions with ease. With a focus on cloud-first and mobile architectures, our approach allows you to take advantage of the latest technologies without the hassle of managing complex integrations.",
            description: "By leveraging our platform and re-usable components, we enable quicker development cycles, fewer human errors and faster time-to-market for your applications by automating routine and time-consuming aspects of development.   \n   At Aargus, we are committed to developing modern applications that bring people, processes, and technology together to build productive, reliable, and scalable solutions",
            features: [
              {
                name: "Platform-based/Re-usable components-based approach",
                tagline: "",
                description: "App-builder platform and library of reusable components enable rapid application development reducing time-to-market for your business."
              },
              {
                name: "Product approach",
                tagline: "",
                description: "Our product-oriented approach quickly aligns to your business needs through agile, secure and poerformance-based approaches."
              },
              {
                name: "Scalable cloud-native architecture",
                tagline: "",
                description: "We build scalable and could native solutions which seamlessely integrated with your disparate technology landscape."
              },
              {
                name: "Automation",
                tagline: "",
                description: "We build scalable and could native solutions which seamlessely integrated with your disparate technology landscape."
              } 
            ],
            benefits: [
              "Governance and guardrails",
              "Balanced governance and guidance ensure quality, security and easy monitoring, all while encouraging innovation and agility",
         
            ],
            image:app_dev,
            caseStudies: [
              {
                client: "Global Financial Services Firm",
                challenge: "Needed to transition 5,000+ employees to remote work during pandemic",
                solution: "Implemented comprehensive digital workplace solution with cloud-based tools and secure access",
                results: "98% operational continuity with 25% increase in employee satisfaction"
              }
            ]
          },
          "Application Maintainance": {
            title: "Application Maintainance",
            subtitle: "Streamline your operations with robust Application Management Services—ensuring optimal performance, scalability, and innovation for your digital assets.",
            description: "Comprehensive Application Management Services to monitor, maintain, and optimize your business-critical applications—empowering agility, reducing downtime, and driving innovation for seamless digital growth.",
            features: [
              {
                name: "24X7 Monitoring and Support",
                tagline: "Proactive issue resolution",
                description: "Continuous monitoring and detection to ensure uninterrupted operations."
              },
              {
                name: "Performance Optimization",
                tagline: "Peak performance, minimal latency",
                description: "Regular tuning of applications for improved speed and reduced delays."
              },
              {
                name: "Scalability",
                tagline: "Seamless growth adaptation",
                description: "Enables applications to expand with growing business needs effortlessly."
              },
              {
                name: "Version Upgrades and Updates",
                tagline: "Stay current and compliant",
                description: "Keeps applications updated with industry standards and latest improvements."
              } ,
              {
                name: "Enhanced Security",
                tagline: "Robust protection from threats",
                description: "Implements security protocols to safeguard applications from vulnerabilities."
              } ,
              {
                name: "Custom Integrations",
                tagline: "Tailored solutions for workflows",
                description: "Creates application integrations that align with specific business needs."
              } ,
              {
                name: "Cloud and Hybrid Management",
                tagline: "Flexible deployment options",
                description: "Supports cloud-based, on-premises, and hybrid IT environments."
              } 
            ],
            benefits: [
              "Increased Uptime: Minimize disruptions and ensure business continuity.",
              "Improved Performance: Enhance application responsiveness and user experience.",
              "Reduced Costs: Optimize resource utilization and minimize downtime expenses.",
              "Enhanced Security: Protect applications from threats and vulnerabilities.",
              "Faster Innovation: Streamline deployments and updates for rapid development cycles.",
         "Proactive Issue Resolution: Identify and address potential problems before they impact users.",
         "Scalability and Flexibility: Adapt to changing business needs and growth.",
         "Free up internal IT teams to work on strategic projects.",
         "Enhanced User Experience: Faster, secure, and reliable applications tailored to meet user expectations.",
         "Business Continuity: Minimized disruptions with proactive maintenance and rapid issue resolution.",
         "Better customer satisfaction.",
            ],
            image:app_dev,
            caseStudies: [
              {
                client: "Global Financial Services Firm",
                challenge: "Needed to transition 5,000+ employees to remote work during pandemic",
                solution: "Implemented comprehensive digital workplace solution with cloud-based tools and secure access",
                results: "98% operational continuity with 25% increase in employee satisfaction"
              }
            ]
          },
          "Networking": {
            title: "Enterprise Networking Solutions",
            subtitle: "Build a robust, scalable network infrastructure",
            description: "Our networking solutions provide the foundation for your digital transformation with high-performance, secure, and scalable infrastructure designed for modern business needs. From SD-WAN to advanced wireless networks, we deliver comprehensive networking solutions that connect your people, places, and devices seamlessly.",
            features: [
              {
                name: "Software-defined networking (SDN)",
                tagline: "Flexible, programmable network architecture",
                description: "Implement modern SDN solutions that separate control and data planes for greater flexibility and control."
              },
              {
                name: "Advanced wireless network design",
                tagline: "Seamless connectivity for your entire organization",
                description: "Deploy cutting-edge wireless networks that provide reliable coverage and high performance."
              },
              {
                name: "Network security and compliance",
                tagline: "Protecting your critical infrastructure",
                description: "Implement comprehensive security measures to safeguard your network from threats."
              },
              {
                name: "Performance optimization",
                tagline: "Maximizing speed and reliability",
                description: "Fine-tune your network for optimal performance, minimizing latency and maximizing throughput."
              },
              {
                name: "Cloud connectivity",
                tagline: "Seamless integration with cloud services",
                description: "Connect your on-premises network to cloud resources securely and efficiently."
              },
              {
                name: "24X7 network management",
                tagline: "Always-on monitoring and support",
                description: "Ensure your network is always performing optimally with round-the-clock management and support."
              }
            ],
            benefits: [
              "Improve network reliability and uptime",
              "Enhance security posture and threat protection",
              "Scale bandwidth efficiently as needs grow",
              "Reduce operational costs through automation",
              "Enable seamless cloud integration",
              "Support remote and mobile workforce"
            ],
            image: "/images/networking.jpg",
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          // More services would be defined here
        },
        "Cloud": {
          "SecDevOps": {
            title: "SecDevOps",
            subtitle: "Bridging the Gap Between Development and Operations",
            description: "By embracing SecDevOps Services, organizations can achieve greater agility, collaboration, and efficiency in their software development and operations. Our comprehensive SecDevOps solution empowers teams to deliver high-quality software faster and more reliably, driving business growth and innovation",
            features: [
              {
                name: "Continuous Integration and Continuous Deployment (CI/CD): ",
                tagline: "",
                description: "Automate the build, test, and deployment process. Ensure faster and more reliable software releases."
              },
              {
                name: "Infrastructure as Code (IaC): ",
                tagline: "",
                description: "Define and manage infrastructure using code and automation. Achieve consistency and scalability in infrastructure management."
              },
              {
                name: "Version Control Integration:",
                tagline: "",
                description: "Seamless integration with version control systems like Git. Track changes and collaborate efficiently on code."
              },
              {
                name: "Automated Testing: ",
                tagline: "",
                description: " Implement automated testing at every stage of the development lifecycle. Ensure high-quality software by catching bugs early."
              } ,
              {
                name: "Monitoring and Logging: ",
                tagline: "",
                description: "Real-time monitoring and logging of applications and infrastructure. Quickly identify and resolve issues to maintain uptime and performance."
              } ,
              {
                name: "Collaboration Tools:",
                tagline: "",
                description: " Enhanced communication and collaboration between development and operations teams. Use of tools like Slack, Jira, and Trello for efficient project management."
              } ,
              {
                name: "Security Integration:",
                tagline: "",
                description: "Embed security practices within the DevOps pipeline. Conduct continuous security assessments and vulnerability scans."
              } ,
              {
                name: "Scalability and Flexibility: ",
                tagline: "",
                description: "Scale infrastructure and applications effortlessly to meet business demands. Support for multi-cloud and hybrid environments."
              } 
            ],
            benefits: [
              "Increased Deployment Speed: Faster release cycles with automated CI/CD pipelines. Reduced time-to-market for new features and updates.",
              "Improved Collaboration: Enhanced communication and collaboration between development and operations teams. Break down silos and foster a culture of shared responsibility.",
              "Higher Quality Software: Automated testing ensures early detection of defects. Continuous monitoring and feedback lead to improved software quality.",
              "Scalability and Flexibility: Easily scale applications and infrastructure to meet changing business needs. Support for diverse environments, including on-premises, cloud, and hybrid.",
              "Enhanced Security: Integrate security practices within the development lifecycle. Proactively identify and address security vulnerabilities.",
              "Cost Efficiency: Optimize resource utilization and reduce infrastructure costs. Automate repetitive tasks to free up valuable time and resources.",
              "Increased Reliability: Real-time monitoring and logging ensure high availability and performance. Rapidly identify and resolve issues to maintain operational stability.",
              "Data-Driven Decision Making: Leverage analytics and insights from monitoring and logging. Make informed decisions to improve processes and performance."
         
            ],
            image: sec_devops,
            caseStudies: [
              {
                client: "Global Financial Services Firm",
                challenge: "Needed to transition 5,000+ employees to remote work during pandemic",
                solution: "Implemented comprehensive digital workplace solution with cloud-based tools and secure access",
                results: "98% operational continuity with 25% increase in employee satisfaction"
              }
            ]
          },
          "Cloud Management": {
            title: "Cloud Management",
            subtitle: "Simplifying Your Cloud, Amplifying Your Business",
            description: "By leveraging our Cloud Management solution, businesses can achieve greater efficiency, cost savings, and security in their cloud operations. Our comprehensive platform empowers you to simplify cloud management, optimize resources, and focus on driving business growth.",
            features: [
              {
                name: "Centralized Management",
                tagline: "",
                description: "Single platform to manage all cloud resources across multiple providers. Unified dashboard for easy monitoring and control."
              },
              {
                name: "Automation",
                tagline: "",
                description: ": Automated provisioning, scaling, and de-provisioning of cloud resources. Policy-driven automation for routine tasks and workflows."
              },
              {
                name: "Cost Optimization",
                tagline: "",
                description: "Real-time cost monitoring and reporting. Recommendations for cost-saving opportunities and resource utilization."
              },
              {
                name: "Security and Compliance",
                tagline: "",
                description: "Advanced security features including encryption, access control, and threat detection. Compliance with industry standards and regulatory requirements."
              },
              {
                name: "Performance Monitoring:",
                tagline: "",
                description: "Continuous monitoring of cloud resource performance. Customizable alerts and notifications for proactive management."
              },
              {
                name: "Integration Capabilities: ",
                tagline: "",
                description: " Seamless integration with existing IT infrastructure and third-party tools. API support for custom integrations."
              }
              ,
              {
                name: "Scalability: ",
                tagline: "",
                description: "Easily scale resources up or down based on business needs. Support for multi-cloud environments."
              },
              {
                name: "Disaster Recovery: ",
                tagline: "",
                description: "Robust disaster recovery options to ensure business continuity. Data backup and recovery solutions."
              }
            ],
            benefits: [
              "Improved Efficiency: Streamline cloud management tasks with automation and centralized control. Reduce manual effort and administrative workload.",
              "Cost Savings: Optimize cloud spending with real-time cost monitoring and recommendations. Avoid over-provisioning and underutilization of resources.",
              "Enhanced Security: Protect your cloud environment with advanced security features. Ensure compliance with regulatory standards to avoid penalties.",
              "Better Performance: Monitor and optimize cloud resource performance for maximum efficiency. Proactively address performance issues with customizable alerts.",
              "Increased Agility: Quickly respond to changing business demands with scalable cloud resources. Accelerate time-to-market for new applications and services.",
              "Business Continuity: Ensure continuous operation with robust disaster recovery options. Minimize downtime and data loss in the event of disruptions.",
              "Informed Decision-Making: Utilize data analytics to gain insights and optimize cloud operations. Support strategic planning with real-time cloud performance metrics."
            ],
            image:cloud_mgmt,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          "Infra-as-a-Service": {
            title: "Infra-as-a-Service",
            subtitle: "",
            description: "By leveraging Infra as a Service (IaaS), businesses can achieve greater flexibility, efficiency, and security in their IT operations. Our comprehensive IaaS solution empowers you to scale effortlessly, optimize costs, and focus on what matters most—driving innovation and growth.",
            features: [
              {
                name: "Scalable Resources:",
                tagline: "",
                description: "On-demand provisioning of computing resources such as VMs, storage, and network components. Easily scale up or down based on your needs without upfront capital expenditure."
              },
              {
                name: "High Availability:",
                tagline: "",
                description: ":  Ensure business continuity with redundant systems and automatic failover. Guaranteed uptime with robust Service Level Agreements (SLAs)."
              },
              {
                name: "Cost Efficiency:",
                tagline: "",
                description: "Pay-as-you-go pricing model to optimize costs. Eliminate the need for expensive on-premises hardware and maintenance."
              },
              {
                name: "Security and Compliance",
                tagline: "",
                description: " Advanced security features including firewalls, encryption, and identity management. Compliance with industry standards and regulations."
              },
              {
                name: "Flexibility: ",
                tagline: "",
                description: "Support for a wide range of operating systems and applications. Seamless integration with existing IT environments."
              },
              {
                name: "Disaster Recovery:",
                tagline: "",
                description: "Built-in disaster recovery options to protect your data and applications. Quick recovery options to minimize downtime in the event of a disruption."
              }
              ,
              {
                name: "Managed Services: ",
                tagline: "",
                description: "Optional managed services to handle routine IT tasks, freeing up your team for strategic initiatives. 24X7 support from experienced professionals."
              },
              {
                name: "Analytics and Monitoring: ",
                tagline: "",
                description: "Real-time monitoring and analytics to track performance and utilization. Customizable dashboards and alerts for proactive management."
              }
            ],
            benefits: [
              "Increased Agility: Quickly respond to changing business demands with flexible and scalable infrastructure. Accelerate time-to-market for new applications and services.",
              "Cost Savings: Reduce capital expenditure with a pay-as-you-go model. Lower operational costs by outsourcing infrastructure management.",
              "Enhanced Security: Protect your data and applications with advanced security measures. Ensure compliance with regulatory requirements to avoid penalties.",
              "Improved Performance: High-performance computing resources to support demanding workloads. Optimize resource allocation for maximum efficiency.",
              "Business Continuity: Ensure continuous operation with high availability and disaster recovery options. Minimize downtime and data loss in the event of disruptions.",
              "Focus on Core Business: Free up IT staff to focus on strategic initiatives rather than routine maintenance. Leverage managed services for expert support and guidance.",
              "Global Reach: Deploy and manage infrastructure across multiple geographic locations. Ensure consistent performance and availability for users worldwide."
            ],
            image: ias,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          // More services would be defined here
        },
        "Software-as-a-Service": {
          "Financial ERP": {
            title: "     Financial ERP",
            subtitle: "",
            description: "Consolidate financial accounting functions on one platform. It replaces multiple systems and applications and helps oragnization streamline their accounting processes and systems. ",
            features: [
              {
                name: "Improved data flow",
                tagline: "",
                description: "Integrated accounting systems help businesses avoid errors and inconsistencies that can occur when using multiple systems. "
              },
              {
                name: "Reduced costs",
                tagline: "",
                description: "By automating manual tasks, integrated accounting systems can reduce operational costs. "
              },
              {
                name: "Better reporting",
                tagline: "",
                description: "Integrated accounting systems provide real-time data updates that help businesses create more accurate reports. "
              },
              {
                name: "Improved decision making",
                tagline: "",
                description: "Integrated accounting systems provide a comprehensive overview of a business's financial health. "
              } 
            ],
            benefits: [
              "Connects financial data: Integrated accounting systems connect general ledgers, payment systems, tax calculations and inventory management.",
              "Standardizes procedures: Integrated accounting systems help standardize how transactions are recorded and financial information is shared.",
              "Integration: Integration with your business applications like Billing Systems, Payroll, Bill tracking.",
              "Integrated accounting system: Integrated accounting systems can handle inventory purchases, sales, debtors, creditors, Tax.",
              "Consolidated view: Get enterprise, branch as well as unit-level view of your accounting system and reports.",
              "Security: Role-based access, security controls, high availability and business continuity ensure safety, integrity and security of your data.",
            ],
            image: fin_erp,
            caseStudies: [
              {
                client: "Global Financial Services Firm",
                challenge: "Needed to transition 5,000+ employees to remote work during pandemic",
                solution: "Implemented comprehensive digital workplace solution with cloud-based tools and secure access",
                results: "98% operational continuity with 25% increase in employee satisfaction"
              }
            ]
          },
          "Enterprise Asset Management": {
            title: "Enterprise Asset Management",
            subtitle: "",
            description: "Manage all aspects of organisation's assets (IT and non-IT) throughout their lifecycle. Use EAM to plan, optimize and track maintenance, repairs  and inspections. ",
            features: [
              {
                name: "Tracking: ",
                tagline: "",
                description: "Enables real-time monitoring of assets and resources. Enhances visibility and efficiency in operations."
              },
              {
                name: "Inventory Management:",
                tagline: "",
                description: "Streamlines stock tracking and control. Reduces wastage and improves resource allocation."
              },
              {
                name: "Lifecycle Management: ",
                tagline: "",
                description: " Manages the entire asset lifecycle. Optimizes performance from acquisition to disposal."
              },
              {
                name: "Assets Accounting:",
                tagline:"",
                description: "Tracks asset valuation and depreciation. Ensures compliance with financial regulations."
              },
              {
                name: "Asset Maintenance:",
                tagline: "",
                description: "Schedules and tracks maintenance activities. Prevents unexpected breakdowns and downtime."
              },
              {
                name: "Work Management:",
                tagline: "",
                description: "Organizes and assigns tasks efficiently. Enhances workflow and productivity."
              },
              {
                name: "Health & Safety",
                tagline: "",
                description: "Ensures compliance with safety regulations. Reduces workplace hazards and risks."
              },
              {
                name: "Cloud and Mobile Ready:",
                tagline: "",
                description: "Provides accessibility from any location. Supports remote management and monitoring."
              }
            ],
            benefits: [
              "Reduce Costs: EAM helps reduce maintenance costs and the cost of replacing assets.",
              "Increase Efficiency: EAM helps maximize asset utilization and production yield.",
              "Improve Compliance: EAM helps companies comply with regulations and industry standards.",
              "Improve Safety: EAM helps improve safety and reliability.",
              "Reduce Downtime: EAM helps reduce unplanned downtime and improve asset performance.",
             
            ],
            image: eam,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          "Entrprise Service Management": {
            title: "Enterprise Service Management",
            subtitle: "",
            description: "Connect all service points across the organization whether it is for Customers, Partners or employees on one single platform for Service Excellence across.",
            features: [
              {
                name: "Increasing productivity: ",
                tagline: "",
                description: "Using an easy ticket tracking process, enables teams to respond to requests quickly, all in one place, leaving inboxes (and employee's minds) less cluttered."
              },
              {
                name: "Minimizing waste: ",
                tagline: "",
                description: "Mapping processes helps defining activities, resources and more by how much value they add. Eliminate the activities that add no value."
              },
              {
                name: "Enahnced Visibility and Control: ",
                tagline: "",
                description: "Reliable metrics offer a high level of visibility, to help easily identify problem areas."
              },
              {
                name: "Increased Customer and Employee Satisfaction: ",
                tagline:"",
                description: "External as well as Internal users will become more satisfied with request expectations."
              },
              {
                name: "Increasing ROI on Service Management solutions: ",
                tagline: "",
                description: "With more business units using the same ESM solution, the ROI increases drastically."
              },
              
            ],
            benefits: [
              "Centralized Service Catalog: A single point of access for employees to request services from various departments, including IT, HR, facilities and legal with clear descriptions and service level agreements (SLAs).",
              "Automated Workflows: Streamlined processes for service requests, approvals, and task assignments across different departments, reducing manual intervention and improving response time.",
              "Request Management: A system for submitting, tracking and managing service requests from initiation to resolution, including updates and status visibility.",
              "Incident and Problem Management: Identifying root causes of recurring issues, implementing preventive measures, and effectively resolving incidents across different business functions.",
              "Performance Monitoring and Reporting: Real-time insights into service delivery metrics, including response times, resolution rates and customer satisfaction, allowing for performance optimization.",
              "Cross-functional Collaboration: Facilitates communication and collaboration between different departments to address issues and deliver services effectively.",
              "Knowledge Base: A repository of information and documentation readily accessible to employees to self-serve and resolve common issue.",
            ],
            image: esm,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
           
          "Field Force Management": {
            title: "Field Force Management",
            subtitle: "Maximize your field team's potential, in real-time",
            description: "",
            features: [
              {
                name: "Real-time visibility:",
                tagline: "",
                description: "Track field agents' location, activities, and customer interactions in real-time, allowing for immediate insights and informed decision-making. ] "
              },
              {
                name: "Customer data access:",
                tagline: "",
                description: "Provide field agents with complete customer information for personalized service and improved customer satisfaction.  "
              },
              {
                name: "Expense management:",
                tagline: "",
                description: "Track and manage field agent expenses for better cost control.  "
              },
              {
                name: "Automated scheduling:",
                tagline:"",
                description: "Efficiently assign tasks and routes to field agents based on their availability, location, and customer needs. "
              },
              {
                name: "Mobile app integration: ",
                tagline: "",
                description: "Enable field agents to access critical information, update data, and complete tasks directly on their mobile devices. "
              },
              {
                name: "Communication tools:",
                tagline: "",
                description: "Facilitate seamless communication between field agents, managers, and customers through integrated messaging features. "
              },
              {
                name: "Attendance management:",
                tagline: "",
                description: "Monitor employee clock-in and clock-out times, ensuring punctuality and accurate work hour tracking. "
              },
              {
                name: "Performance analytics:",
                tagline: "",
                description: "Monitor key performance indicators (KPIs) to identify areas for improvement and optimize field operations. "
              },
              
            ],
            benefits: [
              "Increased productivity: By streamlining workflows and optimizing routes, field agents can accomplish more tasks efficiently. ",
              "Better decision-making: Access to real-time data allows managers to make informed decisions based on current field conditions. ",
              "Improved customer satisfaction: Real-time updates and prompt service delivery enhance customer experience. ",
              "Cost reduction: Optimized scheduling and expense tracking can lead to cost savings. ",
              "Enhanced team collaboration: Effective communication and data sharing fosters better teamwork among field agents. ",
             "Compliance adherence: Ensure field agents are following company policies and procedures. ",
        
             
            ],
            image: field_force_mgmt,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },

          "Inspection Management": {
            title: "Inspection Management",
            subtitle: "",
            description: "Use Inspection Management for standardized and dynamic  checklists, customized workflows, real-time data collection, mobile access for on-site inspections, document management, risk assessments, defect notifications, reporting capabilities, and compliance verification, all aiming to ensure quality control, identify potential issues early, and maintain regulatory compliance across various industries",
            features: [
              {
                name: "Customizable Checklists:",
                tagline: "",
                description: "Create tailored inspection forms with specific criteria based on product, process, or regulatory requirements. "
              },
              {
                name: "Workflow Management:",
                tagline: "",
                description: "Assign inspections to relevant inspectors, set deadlines, and track progress through the inspection process. "
              },
              {
                name: "Mobile Access:",
                tagline: "",
                description: "Enable inspectors to conduct inspections on-site using mobile devices, capturing data and photos in real-time. "
              },
              {
                name: "Automated scheduling:",
                tagline:"",
                description: "Immediately record inspection findings, including defects, non-conformances, and corrective actions. "
              },
              {
                name: "Document Management:",
                tagline: "",
                description: "Store and retrieve inspection reports, photos, signatures, and other supporting documents electronically. "
              },
              {
                name: "Risk Assessment:",
                tagline: "",
                description: "Identify high-risk areas or suppliers and prioritize inspections accordingly. "
              },
              {
                name: "Defect Notifications:",
                tagline: "",
                description: "Generate alerts when critical issues are detected, enabling prompt corrective actions. "
              },
              {
                name: "Reporting and Analytics:",
                tagline: "",
                description: "Generate comprehensive reports with data visualizations to identify trends, areas for improvement, and compliance status. "
              },
              {
                name: "Compliance Verification:",
                tagline: "",
                description: "Ensure adherence to regulatory standards and industry best practices. "
              },
              {
                name: "Supplier Management:",
                tagline: "",
                description: "Monitor supplier quality through inspection processes and risk assessments. "
              },
              
            ],
            benefits: [
              "Improved Quality Control: Identify and address potential issues early in the production process, leading to higher product quality. ",
              "Cost Reduction: Minimize rework, scrap, and recalls by detecting defects early. ",
              "Enhanced Efficiency: Streamline inspection processes, reducing time and resources spent on inspections. ",
              "Increased Customer Satisfaction: Deliver consistent high-quality products that meet customer expectations. ",
              "Regulatory Compliance: Ensure adherence to industry standards and regulations. ",
             "Data-Driven Decision Making: Access real-time data to identify areas for improvement and make informed decisions. ",
             "Risk Mitigation: Proactively identify and address potential safety hazards. "
        
             
            ],
            image:insp_mgmt,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          "IT Asset Management": {
            title: "IT Asset Management",
            subtitle: "Streamlining Efficiency, Maximizing Value",
            description: "",
            features: [
              {
                name: "Comprehensive Asset Tracking",
                tagline: "Automated inventory management and asset discovery.",
                description: "Real-time tracking of IT assets including hardware, software, and licenses."
              },
              {
                name: "Lifecycle Management",
                tagline: "Scheduled maintenance, upgrades, and replacements.",
                description: "Manage the entire lifecycle of assets from acquisition to disposal."
              },
              {
                name: "Cost Management",
                tagline: "Budget forecasting and cost allocation.",
                description: "Track and manage asset costs, including acquisition, maintenance, and depreciation."
              },
              {
                name: "Compliance and Audit",
                tagline:"Automated audit trails and reporting.",
                description: "Ensure compliance with industry standards and regulations."
              },
              {
                name: "Integration and Compatibility",
                tagline: "API support for custom integrations.",
                description: "Seamless integration with existing IT systems and tools."
              },
              {
                name: "Reporting and Analytics:",
                tagline: "Predictive analytics for proactive decision-making.",
                description: "Detailed reports and dashboards for asset performance, utilization, and costs."
              } 
              ,
              {
                name: "User-Friendly Interface",
                tagline: "Role-based access controls and user permissions.",
                description: "Intuitive and easy-to-use interface for efficient asset management."
              },
              
            ],
            benefits: [
              "Enhanced Efficiency: Streamlined IT asset management, reducing manual effort and administrative workload.",
              "Improved Software Compliance: Automated compliance checks and audit trails to ensure regulatory adherence and reduce penalties.",
              "Cost Savings: Optimized asset utilization, reducing unnecessary purchases and lowering maintenance costs.",
              "Increased Visibility: Real-time asset inventory insights and data-driven decision-making with detailed analytics.",
              "Better Resource Allocation: Efficient resource distribution based on performance and utilization, improving budget management.",
             "Scalability: Accommodates growing IT infrastructure with flexibility to adapt to business needs.",
 
        
             
            ],
            image:itsm,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          "Low-CodeNo-Code Platform": {
            title: "Low-Code/ No-Code Platform",
            subtitle: "",
            description: "By leveraging our Low-Code/ No-Code platform, you can democratize innovation by enabling quick development and launch of services  your business operations, enhance productivity, and foster a culture of innovation. Whether you're a small business or a large enterprise, our platform provides the tools and flexibility you need to succeed in today's fast-paced digital landscape.",
            features: [
              {
                name: "Drag-and-Drop Interface:",
                tagline: "",
                description: " Intuitive, user-friendly interface for building applications without writing code. Pre-built components and templates to accelerate development."
              },
              {
                name: "Customizable Workflows:",
                tagline: "",
                description: " Easily create and modify workflows to fit your unique business processes. Integrate with existing systems and third-party services through APIs."
              },
              {
                name: "Real-Time Collaboration:",
                tagline: "",
                description: "Collaborate with team members in real-time to build and refine applications. Version control and change tracking to manage updates and improvements."
              },
              {
                name: "Scalability:",
                tagline:"",
                description: "Build scalable applications that grow with your business needs. Cloud-based deployment ensures seamless performance and accessibility."
              },
              {
                name: "Security and Compliance:",
                tagline: "",
                description: "Robust security features to protect your data and applications. Compliance with industry standards and regulations."
              },
              {
                name: "Analytics and Reporting:",
                tagline: "",
                description: "Built-in analytics and reporting tools to monitor application performance. Customizable dashboards to track key metrics and insights."
              },
              {
                name: "Integration Capabilities:",
                tagline: "",
                description: "Seamless integration with popular tools and platforms. Connect your applications with databases, CRMs, ERPs, and more."
              },
              {
                name: "Extensibility:",
                tagline: "",
                description: "Extend platform capabilities with custom code when needed. Use pre-built connectors and plugins to enhance functionality."
              },
               
              
            ],
            benefits: [
              "Accelerated Development: Rapidly build and deploy applications without extensive coding knowledge. Reduce time-to-market for new solutions and innovations.",
              "Cost Savings: Lower development costs by eliminating the need for specialized programming skills. Reduce maintenance and operational expenses with streamlined processes.",
              "Enhanced Flexibility: Adapt and modify applications easily to meet changing business requirements. Empower non-technical users to create and manage their own applications.",
              "Improved Collaboration: Foster collaboration between business and IT teams for more effective solutions. Enable cross-functional teams to contribute to application development.",
              "Increased Productivity: Automate repetitive tasks and workflows to save time and resources. Focus on strategic initiatives and innovation rather than manual processes.",
             "Empowerment and Innovation: Empower employees to bring their ideas to life and drive innovation. Democratize application development, making it accessible to everyone in the organization.",
              
        
             
            ],
            image: lowCode,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          "CustomerVendor Registration": {
            title: "Customer/Vendor Registration",
            subtitle: "",
            description: "By leveraging our Centralized Party Registration Portal, businesses can simplify the registration of parties and give them unique identity. Whether you're onboarding new customers, suppliers, or partners, our platform provides the tools and capabilities you need to ensure uniqueness and drive success.",
            features: [
              {
                name: "Unified Registration System:",
                tagline: "",
                description: "Single platform for registering customers, suppliers, and partners. Centralized database for easy access and management."
              },
              {
                name: "Unique Code Generation: ",
                tagline: "",
                description: "Automatic generation of unique identification codes for each registered party. Ensures no duplication and maintains data integrity."
              },
              {
                name: "User-Friendly Interface:",
                tagline: "",
                description: " Intuitive design for easy navigation and registration. Step-by-step guided process for seamless user experience."
              },
              {
                name: "Automated Verification:",
                tagline:"",
                description: "Automated checks for verifying party information. Ensure compliance with regulatory standards and reduce manual errors."
              },
              {
                name: "Secure Data Management:",
                tagline: "",
                description: " Robust security measures to protect sensitive information. Data encryption and secure storage for peace of mind."
              },
              {
                name: "Real-Time Updates:",
                tagline: "",
                description: " Instant notifications and updates on registration status. Real-time tracking of application progress."
              },
              {
                name: "Customizable Forms:",
                tagline: "",
                description: "Tailor registration forms to capture relevant information. Flexible fields and options to suit different business needs."
              },
              {
                name: "Integration Capabilities: ",
                tagline: "",
                description: "Seamlessly integrate with existing ERP and CRM systems. Streamlined data flow for better efficiency and accuracy."
              },
              {
                name: "Analytics and Reporting:",
                tagline: "",
                description: " Comprehensive analytics and reporting tools to monitor registrations. Insights into user demographics and registration trends."
              },
              {
                name: "24X7 Support:",
                tagline: "",
                description: "Dedicated customer support to assist with any queries. Online help center and resources for self-service support."
              },
               
              
            ],
            benefits: [
              "Enhanced Efficiency: Streamlined registration process saves time and reduces administrative workload. Automated verification minimizes manual errors and accelerates onboarding.",
              "Improved Accuracy: Accurate data capture and validation ensure reliable party information. Real-time updates keep stakeholders informed of application progress.",
              "Increased Security: Robust security measures protect sensitive data and ensure compliance with regulatory standards. Secure storage and data encryption safeguard information.",
              "Better User Experience: User-friendly interface and guided process enhance the registration experience. Customizable forms allow for tailored data capture.",
              "Data-Driven Insights: Analytics and reporting tools provide valuable insights into registration trends and user demographics. Informed decision-making based on accurate data.",
             "Seamless Integration: Integration capabilities ensure smooth data flow between systems. Improved efficiency and accuracy with minimal manual intervention.",
              
        
             
            ],
            image: customer_vendor_reg,
            caseStudies: [
              {
                client: "Multinational Retail Corporation",
                challenge: "Struggling with network bottlenecks across 200+ locations",
                solution: "Implemented SD-WAN with intelligent traffic prioritization",
                results: "47% increase in network performance with 30% cost reduction"
              }
            ]
          },
          // More services would be defined here
        },
      };

      // Get the data for the current service
      if (serviceCategory && serviceType && mockServiceData[serviceCategory] && mockServiceData[serviceCategory][serviceType]) {
        setServiceData(mockServiceData[serviceCategory][serviceType]);
      } else {
        // Set a default service if the requested one doesn't exist
        setServiceData({
          title: serviceType || "Our Service",
          subtitle: "Innovative solutions for your business",
          description: "We provide cutting-edge technology solutions tailored to your specific business needs. Our team of experts works closely with you to understand your requirements and deliver customized services that help you achieve your goals.",
          features: [
            {
              name: "Customized solutions",
              tagline: "Tailored to your specific business needs",
              description: "We develop solutions specifically designed to address your unique challenges and requirements."
            },
            {
              name: "Expert implementation and support",
              tagline: "Guidance from industry professionals",
              description: "Our team of experts ensures smooth implementation and provides ongoing support for your solution."
            },
            {
              name: "Scalable architecture",
              tagline: "Ready to grow with your business",
              description: "Our solutions are built to scale seamlessly as your business grows and your needs evolve."
            },
            {
              name: "Integration with existing systems",
              tagline: "Seamless connection with your ecosystem",
              description: "We ensure our solutions work harmoniously with your current technology landscape."
            },
            {
              name: "Comprehensive training",
              tagline: "Empowering your team for success",
              description: "We provide thorough training and documentation to ensure your team can maximize the value of your solution."
            },
            {
              name: "Ongoing maintenance",
              tagline: "Continuous optimization and support",
              description: "We provide regular updates and optimizations to keep your solution running at peak performance."
            }
          ],
          benefits: [
            "Improve operational efficiency",
            "Reduce costs and increase ROI",
            "Enhance customer experience",
            "Stay ahead of competition",
            "Future-proof your business",
            "Focus on your core business while we handle technology"
          ],
          image: "/images/default-service.jpg",
          caseStudies: [
            {
              client: "Enterprise Client",
              challenge: "Needed to modernize legacy systems",
              solution: "Implemented comprehensive digital transformation solution",
              results: "35% increase in efficiency with 40% reduction in IT costs"
            }
          ]
        });
      }

      // Simulate loading delay
      setTimeout(() => {
        setIsLoaded(true);
      }, 500);
    };

    fetchData();
  }, [serviceCategory, serviceType]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic
    console.log("Form submitted:", formData);
    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
    // Show success message
    alert("Thank you for your inquiry! Our team will contact you shortly.");
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 },
    },
  };

  const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { duration: 0.8 }
    },
  };

  if (!isLoaded || !serviceData) {
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <p>Loading amazing content...</p>
      </div>
    );
  }

  return (
    <motion.div
      className="service-page-container"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-pattern"></div>
        <div className="container mx-auto px-4 py-20 md:py-28 relative z-10">
          <div className="grid grid-cols-3 md:grid-cols-2 gap-8 items-center">
            <motion.div variants={itemVariants} className="hero-content">
              <div className="category-badge">
                {serviceCategory || "Our Services"}
                <br />

              </div>
             
              <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold mb-6 gradient-text leading-[2] pb-1 overflow-visible">
                {serviceData.title}
              </h1>
              <div className="animated-bar"></div>
              <p className="text-xl md:text-2xl text-white mb-6 mt-4 font-medium text-shadow">
                {serviceData.subtitle}
              </p>
              <p className="text-white mb-8 text-lg text-shadow font-medium">
                {serviceData.description}
              </p>
              {/* <div className="flex flex-wrap gap-4" style={{ height: "100px" }}></div> */}
              {/* <div className="flex flex-wrap gap-4">
                <motion.button
                  className="primary-button"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Get Started Today
                  <BsArrowRight className="ml-2" />
                </motion.button>
                <motion.button
                  className="secondary-button"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Learn More
                </motion.button>
              </div> */}
            </motion.div>
            
            <motion.div 
              className="hero-image-container"
              variants={itemVariants}
            >
              <div className="image-frame">
                <img
                  src={serviceData.image || "https://via.placeholder.com/600x400"}
                  alt={serviceData.title}
                  className="rounded-lg"  
                />
                <div className="blob-effect"></div>
                <div className="glow-effect"></div>
              </div>
              <div className="stats-card">
                {/* <div className="stat">
                  <span className="stat-value">98%</span>
                  <span className="stat-label">Success Rate</span>
                </div> */}
                {/* <div className="stat">
                  <span className="stat-value">24/7</span>
                  <span className="stat-label">Support</span>
                </div> */}
              </div>
            </motion.div>
          </div>
        </div>
        <div className="wave-divider">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100">
    <defs>
      <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#F23100" />
        <stop offset="100%" stopColor="#ff7a50" />
      </linearGradient>
    </defs>
    <path
      fill="url(#waveGradient)"
      fillOpacity="1"
      d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"
    ></path>
  </svg>
</div>

      </section>

      {/* Features Section */}
      <section className="features-section py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div 
            className="text-center mb-16"
            variants={itemVariants}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#002C78]">
              Key Features & Capabilities
            </h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our comprehensive solution delivers everything you need to transform your business 
              and stay ahead of the competition.
            </p>
          </motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {serviceData.features.map((feature, index) => (
              <motion.div
                key={index}
                className="feature-card"
                variants={itemVariants}
                whileHover={{ y: -10, boxShadow: "0 10px 25px rgba(0, 44, 120, 0.15)" }}
              >
                <div className="feature-icon-wrapper">
                  <div className="feature-icon">
                    <BsCheck2Circle />
                  </div>
                </div>
                <h3 className="font-bold text-xl mb-2 text-[#002C78]">{feature.name}</h3>
                <h4 className="text-blue-600 font-medium text-sm mb-3">{feature.tagline}</h4>
                <p className="text-gray-600">
                  {feature.description || "Our solutions are designed with your business needs in mind, ensuring maximum efficiency and performance."}
                </p>
                <div className="feature-hover-effect"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section with Wave Divider */}
      <div className="wave-divider-top">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100">
          <path fill="#f9fafb" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>
        </svg>
      </div>

      <section className="benefits-section py-16 relative">
        <div className="benefits-bg-pattern"></div>
        <div className="container mx-auto px-4 relative z-10">
          <motion.div 
            className="text-center mb-16"
            variants={itemVariants}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Benefits & Outcomes
            </h2>
            <div className="w-24 h-1 bg-blue-400 mx-auto mb-8"></div>
            <p className="text-white text-lg max-w-2xl mx-auto">
              See how our solutions can transform your business and deliver tangible results.
            </p>
          </motion.div>
          
          <div className="benefits-grid">
            {serviceData.benefits.map((benefit, index) => (
              <motion.div
                key={index}
                className="benefit-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                style={{ '--i': index }}
              >
                <div className="benefit-number">{index + 1}</div>
                <p>{benefit}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <div className="wave-divider-bottom">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100">
          <path fill="#111827" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>
        </svg>
      </div>

      {/* Case Study Section */}
      {/* <section className="case-study-section py-16 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <motion.div 
            className="text-center mb-16"
            variants={fadeInVariants}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-4 gradient-title">
              Success Stories
            </h2>
            <div className="animated-divider mx-auto mb-8"></div>
            <p className="text-gray-300 max-w-2xl mx-auto text-lg">
              See how we've helped organizations like yours achieve remarkable results.
            </p>
          </motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {serviceData.caseStudies.map((caseStudy, index) => (
              <motion.div
                key={index}
                className="case-study-card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                whileHover={{ y: -10 }}
              >
                <div className="case-quote">
                  <FaQuoteLeft />
                </div>
                <div className="shine-effect"></div>
                <div className="client-badge">{caseStudy.client}</div>
                <h3 className="font-bold text-xl mb-3 text-blue-300">The Challenge</h3>
                <p className="mb-4 text-gray-300">{caseStudy.challenge}</p>
                
                <h3 className="font-bold text-xl mb-3 text-blue-300">Our Solution</h3>
                <p className="mb-4 text-gray-300">{caseStudy.solution}</p>
                
                <h3 className="font-bold text-xl mb-3 text-blue-300">The Results</h3>
                <p className="text-gray-300">{caseStudy.results}</p>
                
                <div className="case-study-stars">
                  <BsStarFill />
                  <BsStarFill />
                  <BsStarFill />
                  <BsStarFill />
                  <BsStarFill />
                </div>
                
                <motion.button
                  className="case-study-button"
                  whileHover={{ x: 5 }}
                >
                  Read Full Case Study <BsArrowRight className="ml-2" />
                </motion.button>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Contact Form Section */}
      <section className="contact-section py-16">
        <div className="contact-bg-pattern"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.div
              variants={itemVariants}
              className="contact-content"
            >
              <div className="section-tag">Get Started</div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#002C78]">
                Ready to Transform Your Business?
              </h2>
              <div className="animated-bar-contact mb-6"></div>
              <p className="text-gray-600 mb-8 text-lg">
                Contact our experts today to discuss how our {serviceData.title} can help you 
                achieve your business goals. Fill out the form and we'll get back to you within 24 hours.
              </p>
              
              <div className="contact-info">
                <div className="info-item">
                  <div className="icon">
                    <FiPhone />
                  </div>
                  <div>
                    <h4>Call Us</h4>
                    <p>+91-11-41072677</p>
                  </div>
                </div>
                
                <div className="info-item">
                  <div className="icon">
                    <FiMail />
                  </div>
                  <div>
                    <h4>Email Us</h4>
                    <p>mail@aargusinfotec.com</p>
                  </div>
                </div>
              </div>
              
              <div className="trust-badges">
                <div className="badge">
                  <span className="badge-icon">🔒</span>
                  <span className="badge-text">Secure Communication</span>
                </div>
                <div className="badge">
                  <span className="badge-icon">⏱️</span>
                  <span className="badge-text">24hr Response</span>
                </div>
                <div className="badge">
                  <span className="badge-icon">👍</span>
                  <span className="badge-text">No Obligation</span>
                </div>
              </div>
            </motion.div>
            
            <motion.div
              variants={itemVariants}
              className="contact-form-wrapper"
            >
              <form onSubmit={handleSubmit} className="contact-form">
                <h3 className="text-2xl font-bold mb-6">Get in Touch</h3>
                
                <div className="form-group">
                  <label htmlFor="name">
                    <FiUser className="form-icon" />
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">
                    <FiMail className="form-icon" />
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">
                    <FiPhone className="form-icon" />
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="Your Phone Number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">
                    <FiMessageSquare className="form-icon" />
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows={4}
                  ></textarea>
                </div>
                
                <motion.button
                  type="submit"
                  className="submit-button"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Send Message
                  <BsArrowRight className="ml-2" />
                </motion.button>
                
                <p className="privacy-note">
                  By submitting this form, you agree to our <a href="#">Privacy Policy</a>.
                  We respect your privacy and will never share your information.
                </p>
              </form>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Related Services Section */}
      <section className="related-services py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-12 text-center text-[#002C78]">Related Services</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="related-service-card">
              <div className="service-icon">
                <BsCheck2Circle />
              </div>
              <h3 className="text-xl font-bold mb-2">Cloud Solutions</h3>
              <p className="mb-4">Scalable cloud infrastructure designed for modern businesses.</p>
              <Link to="/services/ICT Infrastructure/Cloud" className="service-link">
                Learn More <BsArrowRight className="ml-1" />
              </Link>
            </div>
            
            <div className="related-service-card">
              <div className="service-icon">
                <BsCheck2Circle />
              </div>
              <h3 className="text-xl font-bold mb-2">Data Center</h3>
              <p className="mb-4">Reliable and secure data center solutions for your business.</p>
              <Link to="/services/ICT Infrastructure/Data Center" className="service-link">
                Learn More <BsArrowRight className="ml-1" />
              </Link>
            </div>
            
            <div className="related-service-card">
              <div className="service-icon">
                <BsCheck2Circle />
              </div>
              <h3 className="text-xl font-bold mb-2">IT Automation</h3>
              <p className="mb-4">Streamline operations with intelligent automation solutions.</p>
              <Link to="/services/Automation/IT Automation" className="service-link">
                Learn More <BsArrowRight className="ml-1" />
              </Link>
            </div>
            <div className="related-service-card">
              <div className="service-icon">
                <BsCheck2Circle />
              </div>
              <h3 className="text-xl font-bold mb-2">iAssetMax™</h3>
              <p className="mb-4">Asset monitoring, management and predictive maintenance suite.</p>
              <Link to="/assetmax" className="service-link">
                Learn More <BsArrowRight className="ml-1" />
              </Link>
            </div>
          </div>
        </div>
        
      </section>
    </motion.div>
  );
};

export default ServicePage;
